export default __webpack_public_path__ + "static/media/magma_egg_1_2_1.f2febb0e.mp4";